<template>
  <v-card elevation="2" outlined shaped tile>
    <v-container>
      <div v-if="setting != null">
        <FormRegister v-if="setting[0].open == 'true'" />
      <h1 class="text-center" v-else>ระบบปิดรับสมัครแล้ว</h1>
      </div>
    </v-container>
  </v-card>
</template>

<script>
import axios from 'axios'
import FormRegister from '@/components/FormRegister.vue'

export default {
  name: 'Register',
  components: {
    FormRegister,
  },
  data: () => ({
    setting: null,
  }),
  mounted() {
    let vm = this
    axios
      .get('https://huahin.ac.th/service/hhreg/api/setting.php')
      .then(function (resp) {
        vm.setting = resp.data.response
      })
  },
}
</script>
